import { useTranslation } from 'react-i18next'
import { invalidateNews, useCreateAdminNews } from 'src/api/news'
import { NewsArticleForm, NewsArticleFormValues } from 'src/forms/NewsArticleForm'
import { ShowDialogProps } from 'src/show-dialog'

const AdminCreateNewsArticleDialog: React.FC<ShowDialogProps> = ({ pop }) => {
  const { t: translate } = useTranslation(['common', 'news'])
  const createMutation = useCreateAdminNews()

  const handleSubmit = async (values: NewsArticleFormValues) => {
    await createMutation.mutateAsync(values)
    invalidateNews.getAdminNews()
    pop(true)
  }

  return (
    <NewsArticleForm
      title={translate('create-news-article', { ns: 'news' })}
      onSubmit={handleSubmit}
      onCancel={() => pop()}
      isLoading={createMutation.isLoading}
      hideTargetMode
    />
  )
}

export default AdminCreateNewsArticleDialog
